import { useMemo } from 'react'
import { isActive } from '../TaskStatus'

const useIsActive = task =>
  useMemo(() => {
    return task ? isActive(task) : false
  }, [task])

export default useIsActive
